import React, { createContext, type ReactNode, useMemo } from 'react';

import { type Locale } from '../locale';

import { SizeContextProvider, type SizeType } from './SizeContext';

const defaultValue = {
    defaultAllowClear: true,
    size: 'default' as const
};

export type ConfigIllustrations = {
    notFound?: string;
};

export type ConfigConsumerProps = {
    defaultAllowClear?: boolean;
    size?: SizeType;
    illustrations?: ConfigIllustrations;
} & Locale;

export const ConfigContext = createContext<ConfigConsumerProps>(defaultValue);

export type ConfigProviderProps = {
    children: ReactNode;
} & ConfigConsumerProps;

export const ConfigProvider = ({
    t,
    currentLanguage,
    defaultAllowClear,
    size,
    children,
    illustrations
}: ConfigProviderProps) => {
    const contextValue = useMemo(() => {
        return {
            t,
            currentLanguage,
            size: size ?? defaultValue.size,
            defaultAllowClear: defaultAllowClear ?? defaultValue.defaultAllowClear,
            illustrations
        };
    }, [currentLanguage, defaultAllowClear, size, illustrations]);

    return (
        <ConfigContext.Provider value={contextValue}>
            <SizeContextProvider size={contextValue.size}>{children}</SizeContextProvider>
        </ConfigContext.Provider>
    );
};
